// extracted by mini-css-extract-plugin
export default {"header":"Pre_header__dOKI9","pre":"Pre_pre__2X9hW","normal":"Pre_normal__ZlctY","break":"Pre_break__b2KOc"};